import { api } from "@/constants"
import { getAuthHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const instantDelivery = {
  instantDeliveries: (params) => {
    const url = api.instantDelivery.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  }
}
export default instantDelivery
